import { LuBugOff, LuChartArea, LuFileChartColumn, LuHouse, LuLanguages, LuLink2, LuPackage } from 'react-icons/lu';

export const DETAIL_ICONS = {
    MAIN: LuHouse,
    LINKED: LuLink2,
    REPORTING: LuFileChartColumn,
    STATISTICS: LuChartArea,
    CONTENT: LuPackage,
    DEBUG: LuBugOff,
    TRANSLATIONS: LuLanguages
};
